import React, { useState, useContext, useEffect ,useRef} from 'react';
import {
  Tooltip,
  Input,
  Avatar,
  Select,
  Dropdown,
  Menu,
  Divider,
  Message,
  Button,
  Form,
  Modal,
  Link,
  Popover,
  Badge,
  Space,
  Statistic
} from '@arco-design/web-react';
import {
  IconSettings,
  IconVideoCamera,
  IconLock,
  IconPoweroff,
  IconSound,
  IconEyeInvisible,
  IconEye,
  IconUser,
  IconPlus,
  IconBug,
  IconNotification,
  IconClose,
  IconDown,
  IconUp,
  IconCalendarClock,
  IconClockCircle
  
} from '@arco-design/web-react/icon';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalState } from '@/store';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import TopList from '@/components/TopList';
import MessageBox from '@/components/MessageBox';
import CustomrService from '@/components/CustomrService';
import IconButton from './IconButton';
//import Settings from '../Settings';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';
import axiosInstance from '@/utils/axiosInstance';
import userInfo1 from '@/utils/userInfo';
const Countdown = Statistic.Countdown;
const now = Date.now();
const FormItem = Form.Item;
function Navbar({ show,webLogo,kfimg,miniprogramQrcode,systemNotice,aliCaptchaPrefix,aliCaptchaSceneIdWeb }: { show: boolean,webLogo:string,kfimg:string,miniprogramQrcode:string,systemNotice:string,aliCaptchaPrefix:string,aliCaptchaSceneIdWeb:string }) {
	const t = useLocale();
	const userInfo = useSelector((state: GlobalState) => state.userInfo);
	const dispatch = useDispatch();
	const [_, setUserStatus] = useStorage('userStatus');
	const [role, setRole] = useStorage('userRole', 'admin');
	const { setLang, lang, theme, setTheme } = useContext(GlobalContext);
	const username = localStorage.getItem('username');
	const expireSecond = localStorage.getItem('expire_second')?Number(localStorage.getItem('expire_second')):0;
	const expireRemind = localStorage.getItem('expire_remind')?localStorage.getItem('expire_remind'):'false';

	const [passwordVisible,setpasswordVisible] = useState(false);
	const [usernameVisible,setusernameVisible] = useState(false);
	const rphone = useRef('');
	const rcodebtn = useRef(false);
	const [qphone,setqphone] =  useState('');
	const [qcodebtn,setqcodebtn] = useState(false);
	const methodType = useRef('');
	
	// 更新日志状态管理
	const [updateLogVisible, setUpdateLogVisible] = useState(false);
	const [expandedVersions, setExpandedVersions] = useState(new Set()); // 默认展开最新版本
	const [updateLogs, setUpdateLogs] = useState([]);
	const [updateLogLoading, setUpdateLogLoading] = useState(false);

	const cphone = (e)=>{
		if(e.length==11){
			setqcodebtn(true);
			rcodebtn.current = true;
		}else{
			setqcodebtn(false);
			rcodebtn.current = false;
		}
		setqphone(e)
		rphone.current = e
	}
	
    let captcha;
    let captcha2;

    const getInstance = (instance) => {
        captcha = instance;
    };
	 const getInstance2= (instance) => {
        captcha2 = instance;
    };
    const captchaVerifyCallback = async (captchaVerifyParam) => {
	
		if(!rcodebtn.current||rtimeNume.current>0){
			if(!rcodebtn.current){
				Message.error('请输入正确的手机号码')
			}
			return {
			    captchaResult: true,
				bizResult: true
			}
		}
		const res = await axiosInstance.post('/sms/send_v2', {
			method:'edit_username',
			captchaVerifyParam:JSON.parse(captchaVerifyParam),
			phone:rphone.current,
		})

		let captchaResult = false;
		let bizResult = false;
		    if (res.data.code === 0) {
				settimeNum(60);
				rtimeNume.current=60
				setisRunning(true)
				Message.success(res.data.msg);
				captchaResult = true;
				bizResult = true;
		    } else {
				if (res.data.code === 90011) {
					captchaResult = false;
					bizResult = false;
					
				}else{
					Message.error(res.data.msg);
					captchaResult = true;
					bizResult = true;
				}
			}
		return {
		    captchaResult: captchaResult,
		    bizResult: bizResult,
		}
    }
	const sleep = (ms) => {
		return new Promise(resolve => setTimeout(resolve, ms));
	};
	const captchaVerifyCallback2 = async (captchaVerifyParam) => {
			await sleep(500); // 暂停2秒
		if(methodType.current=='check'){
			if(rtimeNume1.current>0){
				return {
					captchaResult: true,
					bizResult: true
				}
			}
			const res = await axiosInstance.post('/sms/send_v2', {
				method:'check',
				captchaVerifyParam:JSON.parse(captchaVerifyParam),
				phone:username,
			})

			let captchaResult = false;
			let bizResult = false;
				if (res.data.code === 0) {
					settimeNum1(60);
					rtimeNume1.current=60
					setisRunning1(true)
					Message.success('发送成功');

					captchaResult = true;
					bizResult = true;
				
				} else {
					if (res.data.code === 90011) {
						captchaResult = false;
						bizResult = false;
						
					}else{
						Message.error(res.data.msg);
						captchaResult = true;
						bizResult = true;
					}
				}
			return {
				captchaResult: captchaResult,
				bizResult: bizResult,
			}
		}
		if(methodType.current=='edit_username'){
			if(!rcodebtn.current||rtimeNume.current>0){
				if(!rcodebtn.current){
					Message.error('请输入正确的手机号码')
				}
				return {
					captchaResult: true,
					bizResult: true
				}
			}
			const res = await axiosInstance.post('/sms/send_v2', {
				method:'edit_username',
				captchaVerifyParam:JSON.parse(captchaVerifyParam),
				phone:rphone.current,
			})

			let captchaResult = false;
			let bizResult = false;
				if (res.data.code === 0) {
					settimeNum(60);
					rtimeNume.current=60
					setisRunning(true)
					Message.success('发送成功');
					captchaResult = true;
					bizResult = true;
				} else {
					if (res.data.code === 90011) {
						captchaResult = false;
						bizResult = false;
						
					}else{
						Message.error(res.data.msg);
						captchaResult = true;
						bizResult = true;
					}
				}
			return {
				captchaResult: captchaResult,
				bizResult: bizResult,
			}
 	   }
	}
      // 验证通过后调用
    const onBizResultCallback = ()  => {
        console.log('onBizResultCallback');
    }
	  const onBizResultCallback2 = ()  => {
        console.log('onBizResultCallback');
    }
	useEffect(() => {
		if(usernameVisible){
			
			
			// 初始化第一个验证码
			setTimeout(()=>{
				(window as any).initAliyunCaptcha({
					SceneId: aliCaptchaSceneIdWeb, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
					prefix: aliCaptchaPrefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
					mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
					element: '#captcha-element1', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
					button: '#captcha-button1', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
					captchaVerifyCallback: captchaVerifyCallback2, // 业务请求(带验证码校验)回调函数，无需修改
					onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
					getInstance: getInstance, // 绑定验证码实例函数，无需修改
					slideStyle: {
						width: 360,
						height: 40,
					}, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
					language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
				});
			},1000);
		
			setTimeout(()=>{
				(window as any).initAliyunCaptcha({
					SceneId: aliCaptchaSceneIdWeb, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
					prefix: aliCaptchaPrefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
					mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
					element: '#captcha-element2', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
					button: '#captcha-button2', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
					captchaVerifyCallback: captchaVerifyCallback2, // 业务请求(带验证码校验)回调函数，无需修改
					onBizResultCallback: onBizResultCallback2, // 业务请求结果回调函数，无需修改
					getInstance: getInstance2, // 绑定验证码实例函数，无需修改
					slideStyle: {
						width: 360,
						height: 40,
					}, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
					language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
				});
			},2000);
		}
        return () => {
            // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
        document.getElementById('aliyunCaptcha-mask')?.remove();
        document.getElementById('aliyunCaptcha-window-popup')?.remove();
        }
    }, [usernameVisible]);



	
	const useCountdown = (initialTime = 0) => {
		const [timeText, setTimeText] = useState('获取验证码');
		const [isRunning, setIsRunning] = useState(false);
		const [timeNum, setTimeNum] = useState(initialTime);
		const timeNumRef = useRef(0);


		useEffect(() => {
		let countdown = null;

		const updateCountdown = () => {
			if (timeNum === 0) {
			setIsRunning(false);
			setTimeText('获取验证码');
			return;
			}

			if (isRunning && timeNum > 0) {
			countdown = setTimeout(() => {
				setTimeNum(timeNum - 1);
				timeNumRef.current = timeNum - 1;
				setTimeText(String(timeNum) + 's后重发');
			}, 1000);
			}
		};

		updateCountdown();

		return () => {
			if (countdown) {
			clearTimeout(countdown);
			}
		};
		}, [isRunning, timeNum]);

		return {
		timeText,
		isRunning,
		timeNum,
		timeNumRef,
		setIsRunning,
		setTimeNum,
		setTimeText
		};
	};

  const {
    timeText,
    isRunning,
    timeNum,
    timeNumRef: rtimeNume,
    setIsRunning: setisRunning,
    setTimeNum: settimeNum,
    setTimeText: settimeText
  } = useCountdown();


  const useCountdown1 = (initialTime = 0) => {
		const [timeText1, setTimeText1] = useState('获取验证码');
		const [isRunning1, setIsRunning1] = useState(false);
		const [timeNum1, setTimeNum1] = useState(initialTime);
		const timeNumRef1 = useRef(0);


		useEffect(() => {
			let countdown = null;

			const updateCountdown = () => {
				if (timeNum1 === 0) {
					setIsRunning1(false);
					setTimeText1('获取验证码');
					return;
				}

				if (isRunning1 && timeNum1 > 0) {
					countdown = setTimeout(() => {
						setTimeNum1(timeNum1 - 1);
						timeNumRef1.current = timeNum1 - 1;
						setTimeText1(String(timeNum1) + 's后重发');
					}, 1000);
				}
			};

			updateCountdown();

			return () => {
				if (countdown) {
				clearTimeout(countdown);
				}
			};
		}, [isRunning1, timeNum1]);

		return {
		timeText1,
		isRunning1,
		timeNum1,
		timeNumRef1,
		setIsRunning1,
		setTimeNum1,
		setTimeText1
		};
	};

	const {
		timeText1,
		isRunning1,
		timeNum1,
		timeNumRef1: rtimeNume1,
		setIsRunning1: setisRunning1,
		setTimeNum1: settimeNum1,
		setTimeText1: settimeText1
	} = useCountdown1();

  	const [form] = Form.useForm();
	const [form1] = Form.useForm();

	const expireTimeStr = localStorage.getItem("expire_time_str");
	const isExpire = localStorage.getItem("is_expire");
	const sphNum = localStorage.getItem("sph_num");
	const maxSphNum = localStorage.getItem("service_sph_num");
	const showBadge = localStorage.getItem('showBadge');
	const [isShowBade,setisShowBade] = useState(showBadge);
	const [hideStatus,sethideStatus] = useState(localStorage.getItem("navHide")=='1'?true:false);
	useEffect(() => {
		userInfo1.info();
		userInfo1.config();
	}, [])
	useEffect(()=>{
			if(hideStatus){
				localStorage.setItem("navHide",'1');
			}else{
				localStorage.setItem("navHide",'2');
			}
	},[hideStatus])
	function logout() {
		setUserStatus('logout');
		localStorage.removeItem('username');
		localStorage.removeItem('menuKey');
		window.location.href = '/home/login';
	}

	/**
	 * 切换版本详情的展开/收起状态
	 * @param {string} version - 版本号
	 */
	const toggleVersionExpand = (version: string) => {
		const newExpanded = new Set(expandedVersions);
		if (newExpanded.has(version)) {
			newExpanded.delete(version);
		} else {
			newExpanded.add(version);
		}
		setExpandedVersions(newExpanded);
	};

	/**
	 * 获取更新类型的图标和颜色
	 * @param {string} type - 更新类型
	 * @returns {object} 包含图标和颜色的对象
	 */
	const getUpdateTypeStyle = (type: string) => {
		const styles = {
			feature: { icon: <IconPlus />, color: '#00B42A', bgColor: '#E8F5E8', label: '新功能' },
			optimize: { icon: <IconSettings />, color: '#165DFF', bgColor: '#E6F4FF', label: '优化' },
			fix: { icon: <IconBug />, color: '#F53F3F', bgColor: '#FFECE8', label: '修复' }
		};
		return styles[type] || styles.feature;
	};

	/**
	 * 获取版本类型的标签样式
	 * @param {string} type - 版本类型
	 * @returns {object} 样式对象
	 */
	const getVersionTypeStyle = (type: string) => {
		const styles = {
			major: { color: '#F53F3F', bgColor: '#FFECE8', label: '重大更新' },
			minor: { color: '#FF7D00', bgColor: '#FFF7E8', label: '功能更新' },
			patch: { color: '#00B42A', bgColor: '#E8F5E8', label: '问题修复' }
		};
		return styles[type] || styles.minor;
	};

	function onMenuItemClick(key) {
		if (key === 'logout') {
			logout();
		}else if(key === 'setting'){
			setpasswordVisible(true);
		}else if(key === 'username'){
			setusernameVisible(true);
		}else if(key === 'updateLog'){
			updateLog();
		}else {
			Message.info(`You clicked ${key}`);
		}
	}
	/**
	 * 获取更新日志数据
	 */
	const fetchUpdateLogs = async () => {
		setUpdateLogLoading(true);
		try {
			const res = await axiosInstance.post('/update_log/lists', {});
			const { code, data } = res.data;
			if (code === 0) {
				// 转换API数据格式为组件所需格式
				const formattedLogs = data.map(item => ({
					version: item.version,
					type: item.version_type === 1 ? 'major' : 'minor', // 1=重大更新(major), 2=功能更新(minor)
					date: item.log_time,
					updates: item.log_data.map(logItem => ({
						type: getLogType(logItem.type), // 转换日志类型
						content: logItem.content
					}))
				}));
				setUpdateLogs(formattedLogs);
				// 默认展开第一个版本
				if (formattedLogs.length > 0) {
					setExpandedVersions(new Set([formattedLogs[0].version]));
				}
			} else {
				Message.error('获取更新日志失败');
			}
		} catch (error) {
			Message.error('获取更新日志失败');
		} finally {
			setUpdateLogLoading(false);
		}
	};

	/**
	 * 转换日志类型
	 * @param {string} type - API返回的类型 (1=新功能, 2=优化, 3=修复)
	 * @returns {string} 组件使用的类型
	 */
	const getLogType = (type) => {
		switch (type) {
			case '1':
				return 'feature'; // 新功能
			case '2':
				return 'optimize'; // 优化
			case '3':
				return 'fix'; // 修复
			default:
				return 'feature';
		}
	};

	/**
	 * 显示更新日志弹窗
	 */
	const updateLog = () => {
		setUpdateLogVisible(true);
		fetchUpdateLogs();
	};
  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: {
          ...userInfo,
          permissions: generatePermission(role),
        },
      },
    });
  }, [role]);
  
  if (!show) {
    return (
      <div className={styles['fixed-settings']}>
       {/*
	   <Settings
	      trigger={
	        <Button icon={<IconSettings />} type="primary" size="large" />
	      }
	    />
	   */} 
      </div>
    );
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };


  
  const roleMold = localStorage.getItem("role");
  const inviteMenuState = localStorage.getItem("invite_menu_state");
  const systemType = localStorage.getItem("systemType");
  
  let tabList = [];
  if(roleMold=='2'){
	tabList = [
		{
			name: '首页',
			router:'/index/index'
		},
		{
			name: '短视频',
			router:'/short-video/launch-data/launch-data'
		},
		{
			name: '直播间',
			router:'/live/launch-data/launch-data'
		},
		{
			name: '商品卡',
			router:'/product-card/launch-data/launch-data',
			isNew: true
		},
		{
		  name: '小店',
		  router:'/shop/order-list/order-list'
		},
		// {
		//   name: '小店推',
		//   router:'/vhop/launch-data/promotion-shop'
		// },
		// {
		//   name: '合作商家',
		//   router:'/troupe/supplier/supplier'
		// },
		{
		  name: '帐号管理',
		  router:'/management/video-account'
		},
	
		// {
		//   name: '会员服务',
		//   router:'/price/price'
		// },
		{
		  name: '学习中心',
		  router:''
		}
		// {
		//   name: '直播播',
		//   router:'/assistant/assistant-data'
		// }
	
	];
  }else if(roleMold=='3'){
	  tabList = [
		{
		  name: '首页',
		  router:'/index/index'
		},
	  	{
	  	  name: '杠杆审核',
	  	  router:'/live/lever/process'
	  	},

	  	{
	  	  name: '帐号管理',
	  	  router:'/management/video-account'
	  	}
	  ];
  }else{
	  tabList = [
	    {
	      name: '首页',
	  	  router:'/index/index'
	    },
	    {
	      name: '短视频',
	      router:'/short-video/launch-data/launch-data'
	    },
	  	{
	  	  name: '直播间',
	  	  router:'/live/launch-data/launch-data'
	  	},
		{
		  name: '商品卡',
		  router:'/product-card/launch-data/launch-data',
		  isNew: true
		},
		{
		  name: '小店',
		  router:'/shop/shop'
		},
		// {
		//   name: '小店推',
		//   router:'/vhop/launch-data/promotion-shop'
		// },
	  	// {
	  	//   name: '合作商家',
	  	//   router:'/troupe/supplier/supplier'
	  	// },
	  	{
	  	  name: '帐号管理',
	  	  router:'/management/video-account'
	  	},
	  	{
	  	  name: '会员服务',
	  	  router:'/price/price'
	  	},
		{
		  name: '邀请奖励',
		  router:'/invite/invite'
		},
		{
		  name: '学习中心',
		  router:''
		},
		// {
		//   name: '直播播',
		//   router:'/assistant/assistant-data'
		// }
	  
	  ];
  }
	tabList.map((item,index)=>{
		if(systemType=='2'){
			// if(item.name=='邀请奖励'){
			// 	tabList[index]['router'] = '/invite/inviteab'
			// }
			if(item.name=='会员服务'){
				//tabList[index]['router'] = '/price/priceab'
				tabList[index]['router'] = '/price/price'
			}
		}
		
	
	})

	if(inviteMenuState=='false'){
		tabList = tabList.filter(item => item.name !== "邀请奖励");
	}

  function editPassword(oldpassword='',newpassword=''){
	  axiosInstance.post('user/edit_password',{
	  	old_password:oldpassword,
		password:newpassword,
	  })
	  .then((res) => {
	  	const { code, msg } = res.data;
	  	if (res.data.code === 0) {
			form.resetFields();
			setpasswordVisible(false)
				Message.success('成功')
			setTimeout(()=>{
				onMenuItemClick('logout')
			},1500)
	  	}else{
	  		Message.error(msg)
	  	}
	  })
  }
    function editUsername(data){
	  axiosInstance.post('user/edit_username',{
	  	sms_code:data['sms_code'],
	  	edit_username:data['edit_username'],
		edit_sms_code:data['edit_sms_code'],
	  })
	  .then((res) => {
	  	const { code, msg } = res.data;
	  	if (res.data.code === 0) {
			form.resetFields();
			setusernameVisible(false)
			Message.success('成功')
			setTimeout(()=>{
				onMenuItemClick('logout')
			},1500)
			
	  	}else{
	  		Message.error(msg)
	  	}
	  })
  	}

  
  function handleClick(index,name){
  	  localStorage.setItem('menuKey', index);
  }
  




  return (
    <div className={styles.navbar}>
      <div className={styles.left}>
		{systemNotice &&(
			<div className={styles.notice}>
				<div className={styles['notice-roll']}>
					<IconSound style={{fontSize:14,marginRight:2}} />{systemNotice}
				</div>
			</div>
		)}
		<Link  
			href={'/home'+tabList[0]['router']}
			onClick={()=>handleClick(0,'首页')}
			>
			   <div className={styles.logo}>
			   {webLogo !='' &&(
				<>
					<img className={styles['logo-img']}
				  src={webLogo} />
				</>
			   )}

			   </div>
		</Link>
      </div>
	  
	  <TopList data={tabList}>
	  
	  
	  </TopList>
	  <div className={styles['right-div']}>
			<CustomrService kfimg={kfimg} miniprogramQrcode={miniprogramQrcode}>
			
			</CustomrService>
			
			{userInfo && (
			<div className={styles['avatar-wrapper']}>
				
				
				<Popover
				title=""
				onVisibleChange={(e)=>{
					setisShowBade('false')
					localStorage.setItem('showBadge','false');
					
				}}
				  content={
					<div className={styles['menu-list']}>
						<div className={styles['menu-list-eye']}>
							{hideStatus ? (
								<IconEyeInvisible onClick={(e)=>{sethideStatus(!hideStatus)}}/>
							):(
								<IconEye onClick={(e)=>{sethideStatus(!hideStatus)}}/>
							)}
						</div>

						<div className={styles['menu-list-info']}>
							<div className={styles['menu-list-info-row']}>
								<div className={styles['menu-list-info-label']}>
									<IconVideoCamera />
									<span>授权视频号数</span>
								</div>
								<div className={styles['menu-list-info-value']}>
									{sphNum}<span className={styles['menu-list-info-value-sub']}>/{maxSphNum}</span>
								</div>
							</div>
							<div className={styles['menu-list-info-row']}>
								<div className={styles['menu-list-info-label']}>
									<IconClockCircle />
									<span style={isExpire=='true'?{color:'#f53f3f'}:undefined}>到期时间</span>
								</div>
								<div className={styles['menu-list-info-value']} style={isExpire=='true'?{color:'#f53f3f'}:undefined}>
									{expireTimeStr}
								</div>
							</div>
						</div>

						<div className={styles['menu-list-line']}></div>

						<div className={styles['menu-list-action']} onClick={() => onMenuItemClick('updateLog')}>
							<div className={styles['menu-list-action-icon']}>
								<IconCalendarClock />
							</div>
							<div className={styles['menu-list-action-text']}>
								更新日志
							</div>
						</div>

						<div className={styles['menu-list-action']} onClick={() => onMenuItemClick('username')}>
							<div className={styles['menu-list-action-icon']}>
								<IconUser />
							</div>
							<div className={styles['menu-list-action-text']}>
								修改用户名
							</div>
						</div>

						<div className={styles['menu-list-action']} onClick={() => onMenuItemClick('setting')}>
							<div className={styles['menu-list-action-icon']}>
								<IconLock />
							</div>
							<div className={styles['menu-list-action-text']}>
								修改密码
							</div>
						</div>

						<div className={styles['menu-list-line']}></div>

						<div className={styles['menu-list-action']+' '+styles['menu-list-action-danger']} onClick={() => onMenuItemClick('logout')}>
							<div className={styles['menu-list-action-icon']}>
								<IconPoweroff />
							</div>
							<div className={styles['menu-list-action-text']}>
								退出登录
							</div>
						</div>
					</div>
				  }
				>
					<div style={{position:'relative'}}>

				  		<div style={{position:'absolute',top:40,left:-37}}>
							{expireRemind=='true' &&(
							
								<Countdown
									value={now + 1000 * Number(expireSecond)}
									format='即将到期：D 天 H 时 m 分 s 秒'
									now={now}
									styleValue={{fontSize:12,color:'red'}}
								/>
							)}
							
						</div>
						<div style={{ display: 'flex'}}>
							<Avatar size={28} style={{ cursor: 'pointer',marginRight:'8px' }}>
								<img alt="avatar" src='https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/hhhhhhhhhhhhhhhd.png' />
							</Avatar>
							      <Badge
							        count={isShowBade==null?1:0}
							        dot={isShowBade==null?true:false}
							        dotStyle={{ width: 7, height: 7 }}
							      >
									<div style={{display:'flex',alignItems:'center'}} className={styles['avater-wrapper-text']}>
										{hideStatus?(
											<>
												{Number(systemType)==2?'超雄智投':'海豚智投'}
											</>
										):(
											<>
												{username}
											</>
										)}
									</div>
							      </Badge>
							
							<div style={{ cursor: 'pointer',marginLeft:'8px',marginTop:'2px' }}><i className={styles['right-icon']+' iconfont'}>&#xe600;</i></div>
						</div>
						{roleMold=='2' &&(
							<div className={styles['staff-badge-wrapper']}>
								<span className={styles['staff-badge']}>
									<IconUser />
									员工账号
								</span>
							</div>
						)}
					</div>
				</Popover>
			</div>
			)}
	  </div>
		<Modal
		  title={'修改密码'}
		  visible={passwordVisible}
		  onOk={() => form.submit()}
		  onCancel={() => {
			  form.resetFields();
			  setpasswordVisible(false)
		  }}
		  autoFocus={false}
		  focusLock={true}
		>
		  <div className="div-flex" style={{alignItems:'center'}}>
				<Form form={form}
					onSubmit={(v) => {
						editPassword(v['原密码'],v['新密码']);
					}}>
					<FormItem label='原密码' field='原密码' disabled={false}  rules={[{ required: true }]}>
						<Input	
								style={{ width: '85%' }}
								placeholder='请输入原始密码' />
					</FormItem>
					<FormItem label='新密码' field='新密码' disabled={false}  rules={[{ required: true }]}>
						<Input	
								style={{ width: '85%' }}
								placeholder='请输入新密码' />
					</FormItem>
				</Form>
		  </div>
		</Modal>


		<Modal
		  title={'修改用户名'}
		  visible={usernameVisible}
		  onOk={() => form1.submit()}
		  onCancel={() => {
			  form1.resetFields();
			  setusernameVisible(false)
		  }}
		  autoFocus={false}
		  focusLock={true}
		  style={{width:750}}
		>
		  <div  style={{alignItems:'center',width:780,position:'relative'}}>
			
				<Form form={form1}
				labelAlign='left'
					className="div-flex" style={{alignItems:'center',width:780}}
					onSubmit={(v) => {
						editUsername(v);
					}}>
							<Form.Item
							label='本账号手机验证码'
							field="sms_code"
							rules={[{ required: true, message: '本账号手机验证码不能为空'}]}
							>
								<Input style={{width:170}} placeholder='验证码' />
							</Form.Item>
							<div id="captcha-button2"  onClick={(e)=>methodType.current = 'check'} className={timeNum1>=1?styles['ewei-btn-dis']:styles['ewei-btn']} >{timeText1}</div>
							<div id="captcha-element2"></div>
							<FormItem style={{marginTop:20}} label='新账号手机号码' field='edit_username' disabled={false}  rules={[{ required: true , message: '新账号手机号码不能为空'}]}>
								<Input	
										onChange={(e)=>cphone(e)}
										style={{width:290}}
										placeholder='请输入新账号手机号码' />
							</FormItem>
							<Form.Item
							label='新账号手机验证码'
							field="edit_sms_code"
							rules={[{ required: true, message: '新账号手机验证码不能为空'}]}
							>
								<Input style={{width:170}} placeholder='验证码' />
							</Form.Item>
							<div id="captcha-button1" onClick={(e)=>methodType.current = 'edit_username'}  className={!qcodebtn||timeNum>=1?styles['ewei-btn-dis']:styles['ewei-btn']} >{timeText}</div>
							<div id="captcha-element1"></div>
									
								
				</Form>
		  </div>
		</Modal>

		{/* 更新日志弹窗 */}
		<Modal
			visible={updateLogVisible}
			onCancel={() => setUpdateLogVisible(false)}
			footer={null}
			closable={false}
			maskClosable={true}
			style={{
				width: '800px',
				maxWidth: '90vw'
			}}>
			<div style={{
				position: 'relative',
				width: '100%',
				height: '100%',
				background: '#ffffff',
				borderRadius: '12px'
			}}>
				{/* 标题栏 */}
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					marginBottom: '20px',
					paddingBottom: '16px',
					borderBottom: '1px solid #E5E6EB'
				}}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div style={{
							width: '32px',
							height: '32px',
							borderRadius: '8px',
							background: '#E6F4FF',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							marginRight: '12px'
						}}>
							<IconNotification style={{ color: '#165DFF', fontSize: '16px' }} />
						</div>
						<h3 style={{
							color: '#1D2129',
							margin: '0',
							fontSize: '16px',
							fontWeight: '600'
						}}>
							版本更新日志
						</h3>
					</div>
					<Button
						size="small"
						type="text"
						icon={<IconClose />}
						onClick={() => setUpdateLogVisible(false)}
						style={{
							color: '#86909C',
							border: 'none',
							background: 'transparent'
						}}
					/>
				</div>

				{/* 版本列表 */}
				<div style={{ maxHeight: '600px', overflowY: 'auto' }}>
					{updateLogLoading ? (
						<div style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '200px',
							color: '#86909C'
						}}>
							加载中...
						</div>
					) : updateLogs.length === 0 ? (
						<div style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '200px',
							color: '#86909C'
						}}>
							暂无更新日志
						</div>
					) : updateLogs.map((log, index) => {
						const isExpanded = expandedVersions.has(log.version);
						const versionStyle = getVersionTypeStyle(log.type);
						
						return (
							<div key={log.version} style={{
								marginBottom: index === updateLogs.length - 1 ? '0' : '16px',
								border: '1px solid #E5E6EB',
								borderRadius: '8px',
								overflow: 'hidden',
								transition: 'all 0.3s ease'
							}}>
								{/* 版本头部 */}
								<div
									onClick={() => toggleVersionExpand(log.version)}
									style={{
										padding: '16px 20px',
										background: isExpanded ? '#F7F8FA' : '#ffffff',
										cursor: 'pointer',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										transition: 'all 0.3s ease'
									}}
									onMouseEnter={(e) => {
										if (!isExpanded) {
											e.currentTarget.style.background = '#F7F8FA';
										}
									}}
									onMouseLeave={(e) => {
										if (!isExpanded) {
											e.currentTarget.style.background = '#ffffff';
										}
									}}
								>
									<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
										<span style={{
											fontSize: '16px',
											fontWeight: '600',
											color: '#1D2129'
										}}>
											{log.version}
										</span>
										<span style={{
											padding: '2px 8px',
											borderRadius: '4px',
											background: versionStyle.bgColor,
											color: versionStyle.color,
											fontSize: '12px',
											fontWeight: '500'
										}}>
											{versionStyle.label}
										</span>
										<span style={{
											color: '#86909C',
											fontSize: '14px'
										}}>
											{log.date}
										</span>
									</div>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px'
									}}>
										<span style={{
											color: '#86909C',
											fontSize: '12px'
										}}>
											{log.updates.length} 项更新
										</span>
										{isExpanded ? (
											<IconUp style={{ color: '#165DFF', fontSize: '14px' }} />
										) : (
											<IconDown style={{ color: '#86909C', fontSize: '14px' }} />
										)}
									</div>
								</div>

								{/* 版本详情 */}
								{isExpanded && (
									<div style={{
										padding: '5px 20px 20px 20px',
										background: '#ffffff',
										borderTop: '1px solid #E5E6EB'
									}}>
										{log.updates.map((update, updateIndex) => {
											const updateStyle = getUpdateTypeStyle(update.type);
											
											return (
												<div key={updateIndex} style={{
													display: 'flex',
													alignItems: 'flex-start',
													gap: '12px',
													marginBottom: updateIndex === log.updates.length - 1 ? '0' : '12px',
													padding: '12px',
													background: '#F7F8FA',
													borderRadius: '6px',
													border: '1px solid #E5E6EB'
												}}>
													<div style={{
														width: '24px',
														height: '24px',
														borderRadius: '4px',
														background: updateStyle.bgColor,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														flexShrink: 0
													}}>
														<span style={{ color: updateStyle.color, fontSize: '12px' }}>
															{updateStyle.icon}
														</span>
													</div>
													<div style={{ flex: 1 }}>
														<div style={{
															display: 'flex',
															alignItems: 'center',
															gap: '8px',
															marginBottom: '4px'
														}}>
															<span style={{
															padding: '1px 6px',
															borderRadius: '3px',
															background: updateStyle.bgColor,
															color: updateStyle.color,
															fontSize: '10px',
															fontWeight: '500',
															whiteSpace: 'pre-wrap' // 支持换行显示，\n字符会正确显示为换行
														}}>
															{updateStyle.label}
														</span>
														</div>
														<p style={{
															color: '#4E5969',
															lineHeight: '1.5',
															margin: '0',
															fontSize: '14px',
															whiteSpace: 'pre-wrap' // 支持换行显示，\n字符会正确显示为换行
														}}>
															{update.content}
														</p>
													
													</div>
												</div>
											);
										})}
									</div>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</Modal>

    </div>
  );
}

export default Navbar;
